module.exports = __webpack_public_path__ + "static/media/Resume.7bd38938.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resume/Resume.pdf
// module id = 4
// module chunks = 0